import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const toKebabCase = (str) => str
  && str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map((x) => x.toLowerCase())
    .join('-');

const targetsToDataset = (targets = {}) => Object.entries(targets).reduce((acc, [key, value]) => {
  acc[`data-targets-${toKebabCase(key)}`] = value;
  return acc;
}, {});

const AdSlot = (props) => {
  const [containerId, setContainerId] = useState(props.containerId);

  useEffect(() => {
    if (props.containerId !== containerId) {
      setContainerId(containerId);
    }
  }, [props.containerId]);

  return (
    <div
      id={containerId}
      className={`${props.className} ad-slot`}
      data-unit={props.unit}
      data-type={props.type}
      data-mobile-sizes={props.mobileSizes}
      data-desktop-sizes={props.desktopSizes}
      data-keep-size={props.keepSizeOnRefresh}
      {...targetsToDataset(props.targets)}
    />
  );
};

AdSlot.propTypes = {
  containerId: PropTypes.string,
  unit: PropTypes.string,
  type: PropTypes.string,
  mobileSizes: PropTypes.string,
  desktopSizes: PropTypes.string,
  className: PropTypes.string,
  targets: PropTypes.object,
  keepSizeOnRefresh: PropTypes.bool,
};

AdSlot.defaultProps = {
  keepSizeOnRefresh: false,
};

export default AdSlot;
